import { useMemo } from 'react'
import { Checkbox } from '@/components/ui/checkbox'
import { StoreMarkerIcon } from './StoreMarkerIcon'

export interface FilterState {
	brandHouses: boolean
	factoryHouses: boolean
	dealers: boolean
	popUp: boolean
}

interface StoreFiltersProps {
	dictionary: Record<string, string>
	filters: FilterState
	setFilters: (filters: FilterState) => void
	className?: string
}

export default function StoreFilters({ dictionary, filters, setFilters, className }: StoreFiltersProps) {
	const filterItems = useMemo(
		() => [
			{
				id: 'brandHouses',
				label: dictionary['under-armour-brand-houses'],
				icon: 'Brand House',
			},
			{
				id: 'factoryHouses',
				label: dictionary['under-armour-factory-houses'],
				icon: 'Factory House',
			},
			{
				id: 'dealers',
				label: dictionary['under-armour-dealers'],
				icon: 'Dealer',
			},
			{
				id: 'popUp',
				label: dictionary['under-armour-pop-up'],
				icon: 'PopUp',
			},
		],
		[dictionary],
	)
	return (
		<div className={`p-4 space-y-4 ${className}`} role="group" aria-label={dictionary['store-type-filters']}>
			{filterItems.map((item) => (
				<div className="flex items-center space-x-3" key={item.id}>
					<Checkbox
						id={item.id}
						checked={filters[item.id as keyof FilterState]}
						onCheckedChange={(checked) =>
							setFilters({
								...filters,
								[item.id]: checked === 'indeterminate' ? false : checked,
							})
						}
						aria-label={item.label}
					/>
					<div className="flex items-center">
						<StoreMarkerIcon storeType={item.icon} size={24} aria-hidden="true" />
						<label htmlFor={item.id} className="font-medium">
							{item.label}
						</label>
					</div>
				</div>
			))}
		</div>
	)
}
